export const LEAVE_PRIMARY_VIEWS = {
  ACTIVE: 'active',
  CLOSED: 'closed',
};

export const LEAVE_CLOSED_STATUSES = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const PRIMARY_VIEW_OPTIONS = [
  { label: 'Active', value: LEAVE_PRIMARY_VIEWS.ACTIVE },
  { label: 'Closed', value: LEAVE_PRIMARY_VIEWS.CLOSED },
];

export const CLOSED_STATUS_OPTIONS = [
  { label: 'Approved', value: LEAVE_CLOSED_STATUSES.APPROVED },
  { label: 'Rejected', value: LEAVE_CLOSED_STATUSES.REJECTED },
];

export const LEAVE_STATUS_CATEGORIES = {
  ACTIVE: 'active',
  CLOSED: 'closed',
};

export const LEAVE_STATUS_KEYS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

// API returns - Accepted, Rejected, Active
export const API_LEAVE_STATUS_KEYS = {
  Active: 'pending',
  Accepted: 'approved',
  Rejected: 'rejected',
};

export const LEAVE_STATUS = Object.freeze({
  [LEAVE_STATUS_KEYS.PENDING]: {
    key: LEAVE_STATUS_KEYS.PENDING,
    label: 'Pending',
    color: 'warning',
    category: LEAVE_STATUS_CATEGORIES.ACTIVE,
  },

  [LEAVE_STATUS_KEYS.APPROVED]: {
    key: LEAVE_STATUS_KEYS.APPROVED,
    label: 'Approved',
    color: 'success',
    category: LEAVE_STATUS_CATEGORIES.CLOSED,
  },

  [LEAVE_STATUS_KEYS.REJECTED]: {
    key: LEAVE_STATUS_KEYS.REJECTED,
    label: 'Rejected',
    color: 'error',
    category: LEAVE_STATUS_CATEGORIES.CLOSED,
  },
});

/** The labels of the leave_types table (V16): the server binds a leave to its type, and the type decides whether it is paid. */
export const LEAVE_TYPES = Object.freeze({
  CASUAL_LEAVE: 'Casual Leave',
  SICK_LEAVE: 'Sick Leave',
  EARNED_LEAVE: 'Earned Leave',
  COMPENSATORY_OFF: 'Compensatory Off',
  MATERNITY_LEAVE: 'Maternity Leave',
  PATERNITY_LEAVE: 'Paternity Leave',
  LEAVE_WITHOUT_PAY: 'Leave Without Pay',
});

export const LEAVE_TYPE_OPTIONS = Object.keys(LEAVE_TYPES).map((key) => ({
  value: LEAVE_TYPES[key],
  label: LEAVE_TYPES[key],
}));

export const LEAVE_SESSIONS = Object.freeze({
  FIRST_HALF: 'First Half',
  SECOND_HALF: 'Second Half',
  FULL_DAY: 'Full Day',
});

export const LEAVES_SESSION_OPTIONS = [
  {
    value: LEAVE_SESSIONS.FIRST_HALF,
    label: 'Session 1 (First Half of the day)',
  },
  {
    value: LEAVE_SESSIONS.SECOND_HALF,
    label: 'Session 2 (Second Half of the day)',
  },
  { value: LEAVE_SESSIONS.FULL_DAY, label: 'Full Day' },
];

export const EMPTY_TABLE_MESSAGES = {
  [LEAVE_PRIMARY_VIEWS.ACTIVE]: 'No active leave applications found',
  [LEAVE_CLOSED_STATUSES.APPROVED]: 'No approved leaves found',
  [LEAVE_CLOSED_STATUSES.REJECTED]: 'No rejected leaves found',
};

export const EMPTY_LEAVES_BY_STATUS = {
  pending: [],
  approved: [],
  rejected: [],
};

export const LEAVE_ACTION_MODES = {
  IDLE: 'idle',
  APPROVE: 'approve',
  REJECT: 'reject',
};
